import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'

// Whether returns show as % or $ per share. The design's MetricText renders
// both and body[data-metric] picks one, so switching needs no re-render.
export type Metric = 'pct' | 'usd'

const KEY = 'pa_metric'
const MetricContext = createContext<{ metric: Metric; setMetric: (m: Metric) => void }>({
  metric: 'pct',
  setMetric: () => {},
})

function initial(): Metric {
  try {
    return localStorage.getItem(KEY) === 'usd' ? 'usd' : 'pct'
  } catch {
    return 'pct'
  }
}

export function MetricProvider({ children }: { children: ReactNode }) {
  const [metric, setMetric] = useState<Metric>(initial)
  useEffect(() => {
    document.body.dataset.metric = metric
    try {
      localStorage.setItem(KEY, metric)
    } catch {
      // Private mode or blocked storage: the choice just isn't remembered.
    }
  }, [metric])
  return <MetricContext.Provider value={{ metric, setMetric }}>{children}</MetricContext.Provider>
}

export function useMetric() {
  return useContext(MetricContext)
}
